/* eslint-disable */
import React, { Component } from 'react'; 
import * as wording from '../js/wording.js';
import  './FormPage.scss'
import Button from '../UiComponent/Button';
import HTMLText from '../UiComponent/HTMLText';
import Image from '../UiComponent/Image';
class SuccessPage extends Component {
	constructor(props) {
		super(props);	
		this.state = {
			orderId:window.info.orderNumber,
			sMsg:{}
		};
		this.onBackClicked = this.onBackClicked.bind(this);
		this.onPayClicked = this.onPayClicked.bind(this);
		
	
	}

	componentDidMount() {	
		wording.getWording('/wording/SuccessPage.json').then((wordingJson) => this.setState({sMsg : wordingJson,ready:true}));
	}

	componentWillUnmount() {
	}

	onBackClicked(){
		this.props.history.push(window.info.config.pathname +"/application.html");	
	}
	onPayClicked(){
		window.location.href= window.info.config.pathname +"/payment.html?orderId=" + this.state.orderId;	
	}

	render() {			
		return (
            <div id="SuccessPage">
				<div className='form-title'>
					<div className='form-title-image-overlay'></div>
					<HTMLText className='title-desc' text={this.state.sMsg.formTitleZh +"<br/>" + this.state.sMsg.formTitleEn}/>
				</div>
				<div className='success-content content'>
					<div className='success-desc'><HTMLText text={this.state.sMsg.msg2}/></div>
					<div className='order-id'>{this.state.orderId}</div>
					<div className='success-desc'><HTMLText text={this.state.sMsg.msg3}/></div>
					<div className='success-button-div'>
						<Button	className='submitButton defaultButton' onClickAction={()=> this.onPayClicked()} text={this.state.sMsg.paymentBtn} />
						<Button	className='submitButton defaultButton greyButton' onClickAction={()=> this.onBackClicked()} text={this.state.sMsg.back} />
						
					</div>
					</div>
			</div>
		);
	}
}

export default SuccessPage;